// extracted by mini-css-extract-plugin
export default {"setOfOptions":"styles_setOfOptions__wuV4J","option":"styles_option__BInfb","activeOption":"styles_activeOption__ahac3"};